// extracted by mini-css-extract-plugin
export default {"hero":"TextReveal_hero__9cQ6L","textReveal":"TextReveal_textReveal__DqCN-","fade-in":"TextReveal_fade-in__TNKH8"};